import { differenceInCalendarDays } from 'date-fns';
import i18next from 'i18next';

import Constants from '@/constants';

/**
 * Due dates from the API are date-only (`YYYY-MM-DD`) or UTC-midnight
 * timestamps. Compare UTC calendar days so badges match `formatDateAsUtc`
 * tooltips and are not shifted by the client's local offset.
 */
const asUtcCalendarDate = (value: number | string | Date) => {
  const date = value instanceof Date ? value : new Date(value);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};

/** Calendar days until due (UTC). Negative = overdue, 0 = due today. */
const getCalendarDaysUntilDue = (dueDate: number | string) =>
  differenceInCalendarDays(
    asUtcCalendarDate(dueDate),
    asUtcCalendarDate(new Date()),
  );

export const getDueDateColor = (dueDate: number | string) => {
  const daysUntilDue = getCalendarDaysUntilDue(dueDate);

  return daysUntilDue >= 7
    ? Constants.DUEDATE_COLORS.DARK_GREEN
    : daysUntilDue >= 0
      ? Constants.DUEDATE_COLORS.TAN
      : Constants.DUEDATE_COLORS.PURPLE;
};

export const getDueDateString = (dueDate: number | string) => {
  const daysUntilDue = getCalendarDaysUntilDue(dueDate);
  const weeksUntilDue = Math.floor(daysUntilDue / 7);

  return daysUntilDue === 7
    ? i18next.t('TrainingPlans.accountability.due.oneWeek')
    : daysUntilDue < 0
      ? i18next.t('TrainingPlans.accountability.due.overdue')
      : daysUntilDue === 1
        ? i18next.t('TrainingPlans.accountability.due.oneDay')
        : daysUntilDue === 0
          ? i18next.t('TrainingPlans.accountability.due.today')
          : daysUntilDue < 7
            ? i18next.t('TrainingPlans.accountability.due.xDays', {
                daysLeft: daysUntilDue,
              })
            : daysUntilDue >= 8 && weeksUntilDue === 1
              ? i18next.t('TrainingPlans.accountability.due.oneWeek')
              : i18next.t('TrainingPlans.accountability.due.xWeeks', {
                  weeksLeft: weeksUntilDue,
                });
};
